import { useMutation, useQuery, useQueryClient } from "react-query";
import qs from "qs";

import api from "../../utils/api";
import { invalidate } from "../../helpers/clientHelper";

const COMMENTS = "/comments";

const getComments = ({ queryKey }) => {
  const [, resourceType, resourceId] = queryKey;
  const queryString = qs.stringify({ resourceType, resourceId });
  return api.get(`${COMMENTS}?${queryString}`);
};
export const useGetComments = (resourceType, resourceId) => {
  return useQuery([COMMENTS, resourceType, resourceId], getComments, {
    enabled: !!resourceType && !!resourceId,
  });
};

const postComment = (data) => api.post(COMMENTS, data);
export const usePostComment = () => {
  const queryClient = useQueryClient();
  return useMutation(postComment, {
    onSuccess: () => {
      invalidate(queryClient, COMMENTS);
    },
  });
};

const putComment = ({ id, body }) => api.put(`${COMMENTS}/${id}`, { body });
export const usePutComment = () => {
  const queryClient = useQueryClient();
  return useMutation(putComment, {
    onSuccess: () => {
      invalidate(queryClient, COMMENTS);
    },
  });
};

const deleteComment = (id) => api.delete(`${COMMENTS}/${id}`);
export const useDeleteComment = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteComment, {
    onSuccess: () => {
      invalidate(queryClient, COMMENTS);
    },
  });
};

const postReaction = ({ id, emoji }) =>
  api.post(`${COMMENTS}/${id}/reactions`, { emoji });
export const usePostReaction = () => {
  const queryClient = useQueryClient();
  return useMutation(postReaction, {
    onSuccess: () => {
      invalidate(queryClient, COMMENTS);
    },
  });
};
